<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">                  
        <tabulator
            :columns="[
                {
                    title: 'Action', 
                    field: 'description', 
                    sorter: 'string',
                    minWidth: 200,
                    variableHeight: true,
                },                    
                {
                    title: 'Performed By', 
                    field: 'performed_by_for_human', 
                    sorter: 'string',
                    minWidth: 200,
                },
                {
                    title: 'Performed To', 
                    field: 'performed_to_for_human', 
                    sorter: 'string',
                    minWidth: 150,  
                },
                {
                    title: 'Date', 
                    field: 'created_at_for_human',
                    minWidth: 200,
                },
            ]"
            ajax-path="admin/logs"
            @rowSelected="details"
        />
        <app-modal
            :show.sync="showDetailsModal"
            width="lg:w-1/2"
        >
            <template slot="header">Details</template>
            <template slot="body">
                <div style="display: grid;grid-gap: 1rem;grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));">
                    <div>
                        <div class="mb-2 font-bold">Action</div>
                        <div>{{ log.description }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Performed By</div>
                        <div>{{ log.performed_by_for_human }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Performed To</div>
                        <div class="break-all">{{ log.performed_to_for_human }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Date</div>
                        <div>{{ log.created_at_for_human }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">IP</div>
                        <div>{{ log.ip }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">User Agent</div>
                        <div>{{ log.user_agent }}</div>
                    </div>
                </div>
                <template v-if="log.action === 'updated'">
                    <hr class="border-t mt-5">
                    <h2 class="font-thin tracking-widest uppercase mt-4 mb-2">Changes</h2>
                    <div style="display: grid;grid-gap: 1rem;grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));">
                        <div 
                            v-for="(modified, key) in log.modified"
                        >
                            <div class="mb-2 font-bold">{{ key }}</div>
                            <div class="bg-red-200 p-2 break-all text-red-700">
                                {{ modified.old }}
                            </div>
                            <div class="bg-green-200 p-2 break-all text-green-700">
                                {{ modified.new }}
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </app-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    
    export default {
        data() {
            return {
                showDetailsModal: false,
                log: {
                    properties: {},
                    causer: {}
                },
            }
        },
        computed: {
            ...mapGetters({
                items: 'admin/logs/items',
                roles: 'admin/roles/items',
                permissions: 'admin/permissions/items',
            }),
        },
        methods: {
            details(row) {
                this.log = row.data;
                this.showDetailsModal = true;
            },
        }
    }
</script>